import { Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

import { pxToRem } from '@/theme/typography';
import { FormattedMessage } from 'react-intl';
import ImageBoxFuture from '@/components/shared/image-box-future';

const showTimeOfferIcon = '/icons/shared/show-time-offer-icon.svg';

export const OfferTag: FC = () => {
  const theme = useTheme();
  return (
    <Stack
      direction='row'
      sx={{
        p: '4px 8px',
        borderRadius: '20px',
        fontSize: { mobile: '14px', tablet: pxToRem(14) },
        backgroundColor: theme.palette.orange.light,
        width: 'fit-content',
        mt: pxToRem(8),
      }}
    >
      <ImageBoxFuture
        img={showTimeOfferIcon}
        objectFit='contain'
        sx={{
          width: '16px',
          height: '16px',
          mr: pxToRem(8),
        }}
      />
      <Typography
        sx={{
          fontSize: { mobile: '14px', tablet: pxToRem(14) },
          color: theme.palette.orange.main,
        }}
      >
        <FormattedMessage id='offer.available' />
      </Typography>
    </Stack>
  );
};
